import React from 'react';
import Button from 'components/ui/Button';
import { Modal } from 'antd';
import EditHistoryModalContent from './EditHistoryModalContent';

export default function EditHistoryButton({ template }) {
  const [visible, setVisible] = React.useState(false);
  return (
    <>
      <Button onClick={() => setVisible(true)}>Edit History</Button>
      <Modal
        title={`Edit History of Template ${template.id}`}
        visible={visible}
        width={1000}
        onCancel={() => setVisible(false)}
      >
        <EditHistoryModalContent template={template} />
      </Modal>
    </>
  );
}
